

































































































































































































import {
  defineComponent,
  onMounted,
  reactive,
  ref,
  Ref,
} from '@vue/composition-api';
import { useRouter, useFormat } from '@ideavivat/vivat-2';

import {
  getVote,
  createVote,
  updateVote,
} from '@/api';

import CommonTimePicker from '@/components/CommonTimePicker.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

const PanelWithVoteEditor = defineComponent({
  components: {
    CommonTimePicker,
    CommonModalWithPreset,
  },
  props: {
    edit: {
      default() { return false; },
    },
  },
  setup(props: any) {
    const { route } = useRouter();
    const NOW = new Date();

    const successModal = ref(null);
    const loading = ref(true);

    const deletedChoices: Ref<number[]> = ref([]);
    const runningOrder = ref(0);

    const form = reactive({
      name: '',
      nameEN: '',
      startTime: '00:00:00',
      displayTime: '00:00:00',
      date: NOW,
      autoDisplay: false,
      showResult: false,
      resubmit: false,
      automatedAnswer: 'ขอบคุณที่ร่วมสนุก',
      automatedAnswerEN: 'Thanks for submit answer.',
      question: '',
      questionEN: '',
      type: 'CHOICE',
      choices: [
        /* eslint-disable */
        { id: -1, text: '', text_en: '' },
        { id: -1, text: '', text_en: '' },
      ],
      call: async () => {
        // let result = '';
        // const date = (new Date(``));
        if (props.edit === true) {
          await updateVote(route.value.params.voteId, {
            name: form.name,
            name_en: form.nameEN,
            start_time: form.startTime,
            // start_time: `${date} ${form.startTime}`,
            display_time: form.displayTime,
            scheduled_time: `${form.date} ${form.startTime}`,
            auto_display: form.autoDisplay,
            show_result: form.showResult,
            resubmit: form.resubmit,
            automated_answer: form.automatedAnswer,
            automated_answer_en: form.automatedAnswerEN,
            text: form.question,
            text_en: form.questionEN,
            poll_type: form.type,
            choices: form.choices.map((choice) => ({ ...choice, order: runningOrder.value += 1 })),
            deleteChoices: deletedChoices.value,
          });
        }
        else {
          await createVote(route.value.params.liveId, {
            name: form.name,
            name_en: form.nameEN,
            start_time: form.startTime,
            // start_time: `${date} ${form.startTime}`,
            display_time: form.displayTime,
            scheduled_time: `${form.date} ${form.startTime}`,
            auto_display: form.autoDisplay,
            show_result: form.showResult,
            resubmit: form.resubmit,
            automated_answer: form.automatedAnswer,
            automated_answer_en: form.automatedAnswerEN,
            text: form.question,
            text_en: form.questionEN,
            poll_type: form.type,
            choices: form.choices,
          });
        }
        /* eslint-enable */
        (successModal.value as any).compose({ action: 'บันทึก', entity: 'ข้อมูลเรียบร้อย' });
      },
      state: {
        value: 'READY',
      },
    });

    onMounted(async () => {
      if (props.edit === true) {
        const result = await getVote(route.value.params.voteId);
        form.name = result.name;
        form.nameEN = result.name_en;
        form.startTime = result.start_time;
        form.displayTime = result.display_time;
        form.date = useFormat.date(result.scheduled_time).computerShortDate();
        form.autoDisplay = result.auto_display;
        form.automatedAnswer = result.automated_answer;
        form.automatedAnswerEN = result.automated_answer_en;
        form.showResult = result.show_result;
        form.resubmit = result.resubmit;
        form.question = result.text;
        form.questionEN = result.text_en;
        form.type = result.poll_type;
        form.choices = result.choices.map((choice: any) => ({
          id: choice.id,
          text: choice.text,
          order: choice.order,
          // eslint-disable-next-line
          text_en: choice.text_en,
        })).sort((a: any, b: any) => a.order - b.order);
      }
      loading.value = false;
    });

    function deleteChoiceHandler(index: number) {
      if (form.choices[index].id !== -1) {
        deletedChoices.value.push(form.choices[index].id);
      }
      form.choices.splice(index, 1);
    }

    return {
      form,

      successModal,

      deleteChoiceHandler,
    };
  },
});

export default PanelWithVoteEditor;
